import Link from 'components/Link';
import styled from 'styled-components';

export const TermsContainer = styled.div`
  color: ${(props) => props.theme.color.baliHai};
  font-size: 12px;
  font-weight: 400;
  display: block;
  padding-top: 12px;
`;

export const SignInLink = styled(Link)`
  font-size: 13px;
  display: block;
  padding-top: 15px;
  padding-bottom: 15px;
`;

export const StyledTerms = styled.span`
  line-height: 1.2;
  text-align: left;
  @media (max-width: 350px) {
    font-size: 12px;
  }
`;
